import { gql } from '@apollo/client';
import { GqlOrganization } from '../fragments/organization';

export interface Data {
  organizations: Array<GqlOrganization>;
}

export const QUERY = gql`
  query UserOrganizations {
    organizations {
      id
      uuid
      name
      country
      zipCode
      timezone
    }
  }
`;
